import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardContent, CardHeader, Grid, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DialogNovaObservacao from './DialogNovaObservacao';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';


function FiliadoRegisterObservacoes(props) {
  const {
    filiado,
    setFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack
  } = props;

  const [abrirDialogObservacao, setAbrirDialogObservacao] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [refreshState, setRefreshState] = useState(new Date());
  const [novaObservacao, setNovaObservacao] = useState({
    titulo: null,
    descricao: null
  });
  const [modoEdicaoObservacao, setModoEdicaoObservacao] = useState(false);
  const [indexModoEdicao, setIndexModoEdicao] = useState(-1);

  function deletar(event, index) {
    try {
      event.preventDefault();
      if (filiado.observacoes[index].idFiliadoObservacao) {
        filiado.observacoes[index].deletado = true;
        setFiliado(filiado);
        setRefreshState(new Date());
      }
      else {
        filiado.observacoes.splice(index, 1);
        setFiliado(filiado);
        setRefreshState(new Date());
      }
    }
    catch (e) {
      setTypeSnack('warning');
      setMessageSnack('Ocorreu um erro ao deletar observação');
      setShowMessageSnack(true);
    }
  }

  function editarObservacao(event, index) {
    try {
      setNovaObservacao(
        {
          idFiliadoObservacao: filiado.observacoes[index].idFiliadoObservacao ? filiado.observacoes[index].idFiliadoObservacao : undefined,
          titulo: filiado.observacoes[index].titulo,
          descricao: filiado.observacoes[index].descricao
        }
      );
      setAbrirDialogObservacao(true);
      setModoEdicaoObservacao(true);
      setIndexModoEdicao(index);
    }
    catch (e) {
      setTypeSnack('warning');
      setMessageSnack('Ocorreu um erro ao obter dados da observação para edição');
      setShowMessageSnack(true);
    }
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <DialogNovaObservacao
          filiado={filiado}
          setFiliado={setFiliado}
          abrirDialogObservacao={abrirDialogObservacao}
          setAbrirDialogObservacao={setAbrirDialogObservacao}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
          novaObservacao={novaObservacao}
          setNovaObservacao={setNovaObservacao}
          edicao={modoEdicaoObservacao}
          setEdicao={setModoEdicaoObservacao}
          indexModoEdicao={indexModoEdicao}
          setIndexModoEdicao={setIndexModoEdicao}
        />
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
      >
        <CardHeader
          subheader="Adicione informações que você acha relevante para esse filiado"
          title="Observações"
          action={
            isDesktop &&
            <Button
              color={'primary'}
              variant={'outlined'}
              startIcon={<NoteAddIcon/>}
              fullWidth={!isDesktop}
              onClick={e => setAbrirDialogObservacao(true)}
            >
              NOVA OBSERVAÇÃO
            </Button>
          }
        />
      </Grid>
      {
        !isDesktop &&
        <Grid
          item
          md={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            color={'primary'}
            variant={'outlined'}
            startIcon={<CheckCircleIcon/>}
            fullWidth
            onClick={e => setAbrirDialogObservacao(true)}
          >
            NOVA OBSERVAÇÃO
          </Button>
        </Grid>
      }
      <Grid
        item
        md={12}
        xs={12}
      >
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <List >
              {
                filiado.observacoes.map((observacao, index) => {
                  return (
                    !observacao.deletado
                    &&
                    <div>
                      <ListItem
                        alignItems="flex-start"
                        key={index}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <LabelImportantIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={observacao.titulo}
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body2"
                                color="textSecondary"
                                style={{
                                  wordWrap:'break-word'
                                }}
                              >
                                {observacao.descricao}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                        <ListItemSecondaryAction>
                          <Tooltip title="Clique pra editar a observação">
                            <IconButton
                              edge={'end'}
                              onClick={e => editarObservacao(e, index)}
                            >
                              <EditIcon/>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cliquei para deletar a observação">
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={e => deletar(e, index)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </div>
                  );
                })
              }
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Grid>
    </Grid>
  );
}

FiliadoRegisterObservacoes.propTypes = {
  filiado: PropTypes.object.isRequired,
  setFiliado: PropTypes.any.isRequired
};

export default FiliadoRegisterObservacoes;


